<span *ngIf="loading || isActive()">
    <button mat-raised-button [color]="color" [disabled]="!isActive()"
      (click)="setStatus()">
      <mat-spinner [diameter]="24" *ngIf="loading" style="display: inline-block;">
      </mat-spinner>
      {{text}}
    </button>
  </span>
  